import script from "./SenderForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SenderForm.vue?vue&type=script&lang=ts&setup=true"

import "./SenderForm.vue?vue&type=style&index=0&id=9719beda&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9719beda"]])

export default __exports__